document.documentElement.classList.remove('no-js');

function initNeneTheme(root = document) {
  const header = document.querySelector('[data-site-header]');
  const syncHeader = () => header && header.classList.toggle('is-scrolled', window.scrollY > 12);
  syncHeader();
  if (!window.__neneHeaderBound) {
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.__neneHeaderBound = true;
  }

  root.querySelectorAll('[data-mobile-toggle]').forEach((btn) => {
    if (btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';
    btn.addEventListener('click', () => {
      const panel = document.querySelector('[data-mobile-nav]');
      if (!panel) return;
      const open = panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden', !open);
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  });

  initEditorialAudio(root);
}

function initEditorialAudio(root = document) {
  const wrappers = [...root.querySelectorAll('[data-nene-video]')];
  if (!wrappers.length) return;

  window.__neneAudioState = window.__neneAudioState || {
    enabled: false,
    active: null,
    ratios: new Map(),
    observer: null
  };
  const state = window.__neneAudioState;

  const allWrappers = () => [...document.querySelectorAll('[data-nene-video]')];

  const setButton = (wrapper, sounding) => {
    const button = wrapper.querySelector('[data-video-sound-toggle]');
    if (!button) return;
    button.setAttribute('aria-pressed', sounding ? 'true' : 'false');
    button.setAttribute('aria-label', sounding ? 'Silenciar música del vídeo' : 'Activar música del vídeo');
    const label = button.querySelector('[data-sound-label]');
    if (label) label.textContent = sounding ? 'Silenciar' : 'Sonido';
  };

  const muteWrapper = (wrapper) => {
    const video = wrapper?.querySelector('video');
    if (!video) return;
    video.muted = true;
    setButton(wrapper, false);
  };

  const applyActiveAudio = async () => {
    const current = state.active;
    allWrappers().forEach((wrapper) => {
      if (wrapper !== current) muteWrapper(wrapper);
    });

    if (!state.enabled || !current || document.hidden) {
      if (current) muteWrapper(current);
      return;
    }

    const video = current.querySelector('video');
    if (!video) return;
    try {
      video.muted = false;
      await video.play();
      setButton(current, true);
    } catch (error) {
      video.muted = true;
      setButton(current, false);
    }
  };

  const chooseMostVisible = () => {
    let best = null;
    let bestRatio = 0;
    allWrappers().forEach((wrapper) => {
      const ratio = state.ratios.get(wrapper) || 0;
      if (ratio > bestRatio) {
        bestRatio = ratio;
        best = wrapper;
      }
    });
    const next = bestRatio >= 0.35 ? best : null;
    if (state.active !== next) {
      state.active = next;
      applyActiveAudio();
    }
  };

  if (!state.observer) {
    state.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => state.ratios.set(entry.target, entry.intersectionRatio));
      chooseMostVisible();
    }, { threshold: [0, .15, .25, .35, .5, .65, .8, 1] });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        allWrappers().forEach(muteWrapper);
      } else {
        applyActiveAudio();
      }
    });
  }

  wrappers.forEach((wrapper) => {
    if (!wrapper.dataset.audioObserved) {
      wrapper.dataset.audioObserved = 'true';
      state.observer.observe(wrapper);
    }

    const video = wrapper.querySelector('video');
    if (video) video.muted = true;

    const button = wrapper.querySelector('[data-video-sound-toggle]');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', async () => {
      const isThisSounding = state.enabled && state.active === wrapper && video && !video.muted;
      if (isThisSounding) {
        state.enabled = false;
        muteWrapper(wrapper);
        return;
      }

      state.enabled = true;
      state.active = wrapper;
      allWrappers().forEach((other) => {
        if (other !== wrapper) muteWrapper(other);
      });
      if (video) {
        try {
          video.muted = false;
          await video.play();
          setButton(wrapper, true);
        } catch (error) {
          video.muted = true;
          setButton(wrapper, false);
        }
      }
    });
  });

  chooseMostVisible();
}

document.addEventListener('DOMContentLoaded', () => initNeneTheme(document));
document.addEventListener('shopify:section:load', (event) => initNeneTheme(event.target));
